<template>
  <div class="user-agreement-wrap">
    <div class="user-agreement" v-html="agreement"></div>
  </div>
</template>
<script>
import { getUserAgreement, getArticleDetails } from "../../utils/api/user";

export default {
  data() {
    return {
      agreement: ""
    };
  },
  computed: {
    // 根据路由参数获取页面标题
    pageTitle() {
      const type = this.$route.query.type;
      switch (type) {
        case "user":
          return "用户协议";
        case "privacy":
          return "隐私协议";
        default:
          return "用户协议";
      }
    }
  },
  mounted() {
    const type = this.$route.query.type;
    // 根据 type 参数加载不同的内容
    if (type === "privacy") {
      getArticleDetails(7).then((res) => {
        if (res.success) {
          this.agreement = res.data;
        }
      });
    } else {
      getUserAgreement().then((res) => {
        if (res.success) {
          this.agreement = res.data.contents;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.user-agreement-wrap {
  background-color: #f9f9f9;
  color: #333333;
  font-size: 14px;
  padding-bottom: 50px;
  .user-agreement {
    overflow: hidden;
    width: 335px;
    margin: 0 auto;
    text-align: left;
    h2 {
      text-align: center;
    }
    .container {
      p {
        line-height: 32px;
        font-size: 14px;
        min-height: 32px;
      }
      .block {
        & > p {
          font-size: 16px;
          font-weight: 700;
        }
        .paragraph {
          .by-law {
          }
        }
      }
    }
  }
}
</style>
